(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-desktop-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-desktop-navigation')) {
    customElements.define('pp-desktop-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.details = Array.from(this.querySelectorAll('.pp-nav__details'));
        this.timers = new Map();
        this.details.forEach(detail => {
          const summary = detail.querySelector('summary');
          summary.setAttribute('aria-expanded', String(detail.open));
          detail.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(detail.open));
            if (detail.open) {
              this.closest('header').querySelectorAll('.pp-nav__details[open]').forEach(other => {
                if (other !== detail) other.open = false;
              });
            }
          }, options);
          detail.addEventListener('keydown', event => {
            if (event.key === 'Escape' && detail.open) {
              event.preventDefault(); event.stopPropagation(); detail.open = false; summary.focus();
            }
          }, options);
          detail.addEventListener('focusout', event => {
            if (!detail.contains(event.relatedTarget)) detail.open = false;
          }, options);
          if (this.dataset.hover === 'true') {
            detail.addEventListener('pointerenter', event => {
              if (event.pointerType !== 'mouse') return;
              clearTimeout(this.timers.get(detail));
              this.timers.set(detail, setTimeout(() => { detail.open = true; }, 120));
            }, options);
            detail.addEventListener('pointerleave', event => {
              if (event.pointerType !== 'mouse') return;
              clearTimeout(this.timers.get(detail));
              this.timers.set(detail, setTimeout(() => {
                if (!detail.contains(document.activeElement)) detail.open = false;
              }, 180));
            }, options);
          }
        });
        document.addEventListener('click', event => {
          this.details.forEach(detail => {
            if (!detail.contains(event.target)) detail.open = false;
          });
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort(); this.timers?.forEach(timer => clearTimeout(timer));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-device-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-device-options')) {
    class PPDeviceOptions extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), {once:true});
        } else {
          this.initialize();
        }
      }
      disconnectedCallback() {
        this.root?.removeEventListener('change', this.onNativeChange);
        this.root?.removeEventListener('variant:change', this.onVariantChange);
      }
      initialize() {
        if (this.ready) return;
        this.form = document.getElementById(this.dataset.formId);
        this.root = this.closest('[data-product-id]');
        if (!this.form || !this.root) return;
        this.ready = true;
        this.labels = JSON.parse(this.querySelector('[data-pp-labels]').textContent);
        this.fields = this.querySelector('.pp-device-options__fields');
        const inputs = [...this.root.querySelectorAll('input[data-variant-input]')].filter(input => input.form === this.form);
        this.group = name => inputs.filter(input => input.name === name);
        this.packed = this.group('Outlet Configuration');
        this.withModel = this.packed.length > 0;
        if (!this.packed.length) this.packed = this.group('Device Configuration');
        this.colors = this.group('Receptacle Color');
        if (!this.colors.length) this.colors = this.group('Frame & Receptacle Color');
        this.amps = this.group('Amperage');
        this.hasDevice = this.packed.length > 0 || (this.colors.length > 0 && this.amps.length > 0);
        this.configs = this.packed.map(input => {
          const parts = input.value.split(' · ');
          return {input,model:this.withModel ? parts[0] : '',color:parts[parts.length-2],amp:parts[parts.length-1]};
        });
        if (!this.packed.length && this.hasDevice) {
          this.configs = this.colors.flatMap(color => this.amps.map(amp => ({color:color.value,amp:amp.value,model:''}))).filter(config => config.color !== 'Ivory' || config.amp === '15A');
        }
        this.state = this.readState();
        if (this.hasDevice) {
          const groups = this.packed.length ? [this.packed] : [this.colors,this.amps];
          groups.forEach(group => group[0]?.closest('.variant-wrapper')?.setAttribute('data-pp-native-hidden',''));
          if (this.withModel) this.createField('model',this.labels.model,[...new Set(this.configs.map(config=>config.model))]);
          this.createField('color',this.dataset.matchFrames === 'true' ? this.labels.matchedColor : this.labels.color,[...new Set(this.configs.map(config=>config.color))]);
          this.createField('amp',this.labels.amp,[...new Set(this.configs.map(config=>config.amp))]);
          this.paint();
        }
        this.onNativeChange = event => {
          if (event.target.matches('[data-variant-input], [data-product-select]')) this.scheduleSync();
        };
        this.onVariantChange = event => {
          if (event.detail?.variant) this.updateStock(event.detail.variant);
          this.scheduleSync();
        };
        this.root.addEventListener('change',this.onNativeChange);
        this.root.addEventListener('variant:change',this.onVariantChange);
        this.scheduleSync();
      }
      readState() {
        if (this.packed?.length) {
          const selected = this.configs.find(config=>config.input.checked) || this.configs[0];
          return {model:selected.model,color:selected.color,amp:selected.amp};
        }
        return {model:'',color:this.colors?.find(input=>input.checked)?.value || '',amp:this.amps?.find(input=>input.checked)?.value || ''};
      }
      createField(key,label,values) {
        const field = document.createElement('fieldset');
        field.className='pp-device-options__field';
        field.dataset.field=key;
        const legend=document.createElement('legend');
        legend.textContent=label;
        field.append(legend);
        const choices=document.createElement('div');
        choices.className='pp-device-options__choices';
        values.forEach(value=>{
          const button=document.createElement('button');
          button.type='button';
          button.className='pp-device-options__choice';
          button.dataset.value=value;
          button.setAttribute('aria-pressed','false');
          if (key==='color') {
            const dot=document.createElement('span');
            dot.className='pp-device-options__dot';
            dot.style.backgroundColor={Black:'#181818',White:'#f8f8f5',Ivory:'#e8dfb9'}[value] || '#ddd';
            dot.setAttribute('aria-hidden','true');
            button.append(dot);
          }
          button.append(document.createTextNode(value));
          button.addEventListener('click',()=>this.choose(key,value));
          choices.append(button);
        });
        field.append(choices);
        this.fields.append(field);
      }
      choose(key,value) {
        this.state[key]=value;
        let candidate=this.configs.find(config=>config.model===this.state.model && config.color===this.state.color && config.amp===this.state.amp);
        if (!candidate) {
          candidate=this.configs.find(config=>config.model===this.state.model && config.amp===this.state.amp && config.color==='Black') || this.configs.find(config=>config.model===this.state.model && config.amp===this.state.amp) || this.configs[0];
        }
        if (!candidate) return;
        this.state={model:candidate.model,color:candidate.color,amp:candidate.amp};
        if (this.packed.length) {
          candidate.input.click();
        } else {
          const color=this.colors.find(input=>input.value===candidate.color);
          const amp=this.amps.find(input=>input.value===candidate.amp);
          if (color && !color.checked) color.click();
          if (amp && !amp.checked) amp.click();
        }
        this.paint();
        this.scheduleSync();
      }
      paint() {
        this.fields.querySelectorAll('[data-field]').forEach(field=>{
          const key=field.dataset.field;
          field.querySelectorAll('button').forEach(button=>{
            const value=button.dataset.value;
            button.hidden=key==='color' && !this.configs.some(config=>config.model===this.state.model && config.amp===this.state.amp && config.color===value);
            button.setAttribute('aria-pressed',String(this.state[key]===value));
          });
        });
        const rule=this.querySelector('[data-pp-device-rule]');
        rule.hidden=!this.configs.some(config=>config.color==='Ivory');
      }
      scheduleSync() {
        requestAnimationFrame(()=>{
          if (!this.isConnected) return;
          if (this.hasDevice) {this.state=this.readState();this.paint();}
          const data=this.root.querySelector('[data-variant-json]');
          if (!data) return;
          const id=this.form.querySelector('[name="id"]')?.value;
          const variants=JSON.parse(data.value || data.textContent);
          const variant=variants.find(item=>String(item.id)===String(id));
          if (variant) this.updateStock(variant);
        });
      }
      updateStock(variant) {
        const toOrder=/^PP-\d{6}-/.test(variant.sku || '');
        this.querySelector('[data-pp-order-status]').hidden=!toOrder;
        this.querySelector('[data-pp-photo-note]').hidden=!toOrder;
        this.root.querySelectorAll('[data-product-inventory]').forEach(label=>{
          const block=label.closest('.product-block');
          if (block) block.style.display=toOrder ? 'none' : '';
        });
      }
    }
    customElements.define('pp-device-options',PPDeviceOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
